import React, { useEffect, useMemo } from "react";
import { useCollection } from "api/hooks/useCollection";
import { Track } from "api/model/Track";
import { Collections } from "api/model/Collections";
import { SelectFieldFormik, SelectOption } from "ui/componentes/Form";
import { useFormikContext } from "formik";

interface SelectTrackCourseProps {
    trackId?: string;
    name: string;
}

const SelectTrackCourse: React.FC<SelectTrackCourseProps> = ({
    trackId,
    name,
}) => {
    const { setFieldValue, values } = useFormikContext<any>();
    const tracksById = useCollection<{ [id: string]: Track }>({
        collection: Collections.TRACKS,
    });

    const coursesOptions =
        useMemo(() => {
            if (!trackId || !tracksById) return [];
            return tracksById[trackId].courses?.map<SelectOption>((course) => ({
                label: course.name,
                value: course.name,
            }));
        }, [tracksById, trackId]) || [];

    useEffect(() => {
        if (
            values[name] &&
            !coursesOptions.map((c) => c.value).includes(values[name])
        ) {
            setFieldValue(name, "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trackId]);

    useEffect(() => {
        if (coursesOptions.length === 1 && !values[name]) {
            setFieldValue(name, coursesOptions[0].value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [coursesOptions, values]);

    return (
        <SelectFieldFormik
            id={name}
            name={name}
            label="Traçado"
            options={coursesOptions}
        />
    );
};

export { SelectTrackCourse };
